export default {
  meta: {
    home: ["A&F Insurance Group, Inc. | Commercial Property & Business Insurance - Fort Lauderdale, Florida", "Independent Florida insurance brokerage with 30+ years of commercial property and business insurance experience. We shop multiple A.M. Best rated markets for you. Call 954-540-2539."],
    about: ["About Us | A&F Insurance Group, Inc. - Fort Lauderdale Insurance Brokerage", "Meet Armando Fuentes and the A&F Insurance Group team. A boutique, independent Fort Lauderdale insurance brokerage with 30+ years of Florida commercial property and business insurance experience."],
    properties: ["Commercial & Habitational Property Insurance | A&F Insurance Group - Florida", "Commercial and habitational property insurance expertise in Florida. Hazard, wind, flood, liability, loss of income and equipment breakdown coverage. Call 954-540-2539 for a quote."],
    business: ["Business Insurance (BOP) & Professional Liability | A&F Insurance Group - Florida", "Business Owners Policy and professional liability insurance for Florida businesses. General liability, property, contents and more. Full service agency: sales, service and claims. Call 954-540-2539."],
    hurricane: ["Florida Hurricane Season Preparedness Guide | A&F Insurance Group", "Florida hurricane season runs June 1 to November 30. Before, during and after the storm checklists, plus insurance coverage review from A&F Insurance Group. Call 954-540-2539."],
    companies: ["Companies We Work With | A&F Insurance Group - A.M. Best Rated Carriers", "A partial list of the insurance carriers A&F Insurance Group works with, including Chubb, Travelers, Lloyd's of London and The Hartford. Companies rated by A.M. Best."],
    quote: ["Request a Quote | A&F Insurance Group, Inc. - Fort Lauderdale, FL", "Request a competitive insurance quote for commercial property, BOP, professional liability, general liability, umbrella or flood coverage in Florida. Call 954-540-2539."],
    accessibility: ["Website Accessibility Statement | A&F Insurance Group, Inc.", "Our commitment to digital accessibility, WCAG 2.1 Level AA conformance goals, and how to request assistance or alternative formats."],
  },
  common: {
    requestQuote: "Request a Quote",
    callNow: "Call Now",
    getQuote: "Get a quote",
    getInsuranceQuote: "Get an Insurance Quote",
    backToHome: "Back to Home",
    hours: "Monday - Friday, 8:00 AM - 6:00 PM",
    hoursShort: "Mon-Fri 8AM-6PM",
  },
  nav: { home: "Home", about: "About Us", properties: "Properties", business: "Business", hurricane: "Hurricane", companies: "Companies" },
  header: { openMenu: "Open menu", closeMenu: "Close menu", homeAria: "A&F Insurance Group home", primaryNav: "Primary", mobileNav: "Mobile", langLabel: "Language", armandoLabel: "Armando:", dianaLabel: "Diana:" },
  footer: {
    blurb: "A full service independent insurance brokerage in Fort Lauderdale, Florida with 30 years of commercial property and business insurance experience. Programs written in the admitted and excess-surplus lines markets. Companies rated by A.M. Best.",
    pages: "Pages",
    contact: "Contact",
    hoursTitle: "Hours",
    rights: "All rights reserved.",
    tagline: "Independent Florida Insurance Brokerage · Fort Lauderdale, FL",
    designedBy: "Website Designed By",
    accessibility: "Accessibility Statement",
    navAria: "Footer",
  },
  home: {
    heroOverline: "Independent Florida Insurance Brokerage · Serving All of Florida",
    heroLines: ["Florida Property &", "Business Insurance", "Expertise.", "Consultant."],
    heroSub: "For 30 years, A&F Insurance Group has helped Florida property owners and businesses protect their investments. As an independent brokerage, we shop multiple A.M. Best rated markets on your behalf - better rates, without compromising quality or service.",
    heroCall: "Call 954-540-2539",
    heroCallDiana: "Call 954-251-7022",
    anniversaryAlt: "30 Years Anniversary badge",
    heroAria: "Introduction",
    scroll: "Scroll",
    statsAria: "Our credentials",
    stats: [
      { value: "30+", label: "Years", sub: "Florida Insurance Experience" },
      { value: "Independent", label: "Agency", sub: "Multiple Insurance Markets" },
      { value: "Florida", label: "Expertise", sub: "Property & Commercial Risk" },
      { value: "Personal", label: "Service", sub: "Boutique Brokerage Approach" },
    ],
    marqueeAria: "Insurance carriers we work with",
    programsOverline: "Insurance Programs",
    programsHeading: "Coverage built for Florida property & business risk",
    programsSub: "Programs are written in the admitted and excess-surplus lines markets with companies rated by A.M. Best. We explain insurance in simple terms.",
    premiumNote: "Premium financing is available.",
    premiumNoteSub: "Flexible payment options for your commercial policies. Companies rated by A.M. Best.",
    serveOverline: "Who We Serve",
    serveHeading: "A boutique service for people who own and run Florida",
    serveSub: "We provide a clear and specific service to the professionals and property interests that keep Florida moving. If you own it, manage it, lend on it or invest in it - we can insure it.",
    serveImageAlt1: "Florida shopping center",
    serveImageAlt2: "Florida condominium building",
    triCounty: "Florida",
    triCountySub: "Statewide Property & Commercial Coverage",
    whyOverline: "Why A&F Insurance Group",
    whyHeading: "Five reasons property owners stay with us for decades",
    hurricaneOverline: "Hurricane Season · June 1 - November 30",
    hurricaneHeading: "Florida storms are not a question of if. Be ready before the season starts.",
    hurricaneSub: "Wind, flood and named-storm coverage decisions should happen before a storm is on the map. Review your policy with us, then use our preparedness guide to protect your property and the people in it.",
    hurricaneGuideBtn: "Hurricane Preparedness Guide",
    hurricaneCallBtn: "Review My Coverage",
    aboutOverline: "Meet Armando",
    aboutHeading: "Advice from a broker who has written Florida risk for three decades",
    armandoQuote: "\u201CToday I am an independent broker with access to more markets and carriers to help my clients find a competitive rate in Florida.\u201D",
    armandoCred: "A boutique brokerage with 30+ years of Florida insurance experience, now fully independent and serving property owners and businesses across the state.",
    aboutLink: "More about A&F",
    aboutImageAlt: "Armando Fuentes, founder and independent insurance broker at A&F Insurance Group",
    yearsBadge: "30+ Years",
    yearsBadgeSub: "Florida Insurance",
    ctaHeading: "Ready for a competitive quote?",
    ctaSub: "Commercial Property, BOP, Professional Liability, General Liability, Umbrella or Flood - tell us what you need and we'll shop our markets for you.",
  },
  programs: {
    "commercial-property": { title: "Commercial Property", desc: "Coverage for office buildings, retail centers, shopping plazas, warehouses and investment properties across Florida." },
    "condo-associations": { title: "Condominium Associations", desc: "Master property and liability policies for condominium associations, tailored to Florida statute requirements." },
    "hoa-associations": { title: "HOA Associations", desc: "Master property and liability policies for homeowners associations, tailored to Florida statute requirements." },
    "hazard-wind": { title: "Hazard & Wind Coverage", desc: "Protection against Florida's most common property perils - hurricane, wind, hail, lightning and more." },
    "liquor-liability": { title: "Liquor Liability", desc: "Specialized protection for restaurants, bars and establishments that sell or serve alcohol." },
    "cyber-liability": { title: "Cyber Liability", desc: "Coverage for data breaches, ransomware, wire fraud and the cost of responding to a cyber event." },
    "general-liability": { title: "General Liability", desc: "Protection from third-party bodily injury, property damage claims and legal defense costs." },
    "umbrella": { title: "Excess & Umbrella Liability", desc: "Higher liability limits that sit above your underlying property and liability policies." },
    "professional-liability": { title: "Professional Liability", desc: "Errors & omissions protection for professionals whose advice or services clients rely on." },
    "directors-officers": { title: "Directors & Officers", desc: "Protects board members, executives and association leadership from personal liability exposure." },
    "crime": { title: "Crime", desc: "Coverage for employee dishonesty, theft, forgery and funds transfer fraud." },
    "business-income": { title: "Loss of Business Income", desc: "Replaces lost revenue and continuing expenses when covered damage interrupts your operations." },
    "flood": { title: "Flood Insurance", desc: "NFIP and private flood options for Florida properties exposed to storm surge and heavy rainfall." },
    "workers-comp": { title: "Workers Compensation", desc: "Employee injury coverage that meets Florida's statutory requirements for employers." },
    "bop": { title: "Business Insurance (BOP)", desc: "A Business Owners Policy bundling property and liability protection for small and mid-size businesses." },
  },
  audiences: [
    "Commercial Property Owners",
    "Condominium & HOA Associations",
    "Landlords",
    "Business Owners",
    "Shopping Centers & Retail Properties",
    "Property Management Companies",
    "Real Estate Investors",
    "Realtors",
    "Lenders",
    "Title Companies",
    "Local & International Investors",
  ],
  why: [
    { num: "01", title: "Independent", desc: "A&F is an independent brokerage - we evaluate multiple insurance markets on your behalf rather than representing a single carrier, so you get more options to choose from." },
    { num: "02", title: "Florida Expertise", desc: "Nearly three decades working with Florida property and commercial insurance risks - hurricanes, wind, flood, sinkholes and the realities of insuring property in this state." },
    { num: "03", title: "Commercial Focus", desc: "Commercial risk is what we know, enjoy and do best - businesses, property owners, associations, landlords, lenders and investors." },
    { num: "04", title: "Personal Service", desc: "A boutique brokerage experience with direct, knowledgeable assistance. You speak with the people who actually handle your account." },
    { num: "05", title: "Risk Management", desc: "We incorporate the basics of risk management into our service - helping you understand your exposure and coverage, not simply selling a policy." },
  ],
  aboutPage: {
    heroOverline: "About Us",
    heroTitle: "Property and business insurance is our strength in the State of Florida",
    heroSub: "We start by understanding the individual needs of our clients and combine a risk management analysis with experience to provide professional advice.",
    meetOverline: "Meet Armando",
    role: "Founder & Independent Broker",
    bio: "\u201CMy experience in insurance expands more than 30 years advising and writing policies for commercial properties and business insurance throughout the State of Florida. Today I am an independent broker with access to more markets and carriers to help my clients find a competitive rate in Florida.\u201D",
    closingPre: "A&F Insurance Group, Inc. is a specialty lines brokerage firm proudly serving the entire State of Florida. Programs are written in the admitted, excess and surplus lines market with companies rated by A.M. Best. For a consultation, call",
    awardTitle: "LUTCF Designation",
    awardSub: "Honor Ring & Leadership Awards",
    portraitAlt: "Portrait of Armando Fuentes, founder of A&F Insurance Group",
    dianaAlt: "Diana Morales, Account Manager at A&F Insurance Group",
    dianaRole: "Account Manager",
    dianaBio: "Diana is our account manager with a keen talent in solving problems and the knowledge to explain coverage. Full service agency: Sales, Service and Claims.",
    officeHeading: "Our Office",
    exchangeAlt: "The Exchange Building, home of A&F Insurance Group in Fort Lauderdale",
  },
  propertiesPage: {
    heroOverline: "Properties",
    heroTitle: "Commercial & habitational properties in Florida",
    heroSub: "Your property is one of the biggest investments we are responsible to protect.",
    detailHeading: "Insuring Florida property can be daunting. It doesn't have to be.",
    intro: "Each property in our state faces specific issues from weather-related damage. With our knowledge and experience, we are confident we can insure your property in a way that fits both your budget and your insurance needs.",
    perilsHeading: "The most common perils in Florida",
    perils: ["Hurricanes / Wind", "Floods", "Tornado", "Sinkholes", "Lightning", "Hail"],
    coverageHeading: "Coverage we place",
    coverage: ["Hazard", "Wind & Ex-Wind", "General Liability", "Contents", "Loss of Income", "Excess Liability", "Flood", "Equipment Breakdown"],
    ctaTitle: "Buying or leasing a property?",
    ctaSub: "Give us a call for a quote - we'll shop admitted and excess-surplus lines markets for you.",
    imageAlt: "South Florida commercial property tower with palm trees",
  },
  businessPage: {
    heroOverline: "Business",
    heroTitle: "Business Owners Policy & Professional Liability",
    heroSub: "Protect your business and property from the unexpected.",
    detailHeading: "Built around how your business actually operates",
    intro: "General liability and professional liability are designed to protect business owners and operators from a wide variety of liability exposures. A&F Insurance Group, Inc. is a full service agency: Sales, Service and Claims.",
    exposuresHeading: "Exposures we protect against",
    exposures: ["Accidents and premises liability", "Negligence claims", "Faulty materials or products sold", "Completed operations", "Contractual liability"],
    financingTitle: "Premium financing is available",
    financingSub: "Flexible payment options for your commercial policies. Companies rated by A.M. Best.",
    factorsTitle: "What shapes your premium",
    factorsIntro: "Your premium is based on:",
    factors: ["Classification & type of business", "Product or service offered", "Years in business", "Revenues and payroll", "Existing coverage", "Claim history"],
    imageAlt: "Modern Florida commercial building with palm tree",
  },
  hurricanePage: {
    heroOverline: "Hurricane Preparedness",
    heroTitle: "Florida Hurricane Season Preparedness Guide",
    heroSub: "Be Ready. Stay Safe. Check your insurance policy coverages with your agent.",
    seasonLabel: "Season: June 1 - November 30",
    peak: "Peak: August - October",
    beforeTitle: "Before the Storm",
    secureTitle: "Secure Your Home",
    kitTitle: "Build Your Kit",
    secure: ["Install hurricane shutters or board windows", "Trim trees & clear yard debris", "Reinforce garage doors & roof straps"],
    kit: ["Water (1 gal/person/day for 7+ days)", "Non-perishable food & manual can opener", "Medications + first aid supplies", "Flashlights + batteries (NO candles)", "Important documents in waterproof bag", "Identify pet-friendly shelters"],
    duringTitle: "During the Storm",
    stayingTitle: "If Staying Home",
    evacTitle: "If Evacuating",
    staying: ["Stay indoors in a windowless room", "Avoid using electronics during lightning", "Monitor NOAA Weather Radio"],
    evacuating: ["Leave early to avoid traffic", "Follow official evacuation routes"],
    afterTitle: "After the Storm",
    safetyTitle: "Safety First",
    damageAlt1: "Hurricane damage to a coastal Florida property",
    damageAlt2: "Palm trees bending in hurricane-force winds",
    after: ["Avoid floodwaters (may contain hazards)", "Watch for downed power lines", "Use generators OUTDOORS (carbon monoxide risk)"],
    calloutText: "Call A&F Insurance Group, Inc. for more information about your coverage before, during or after a storm.",
    bandTitle: "Review your wind & flood coverage before the season",
    bandSub: "Hurricane deductibles, named-storm exclusions and flood gaps are best fixed while the Atlantic is quiet.",
  },
  companiesPage: {
    heroOverline: "Companies",
    heroTitle: "A vast network of insurance markets, working for you",
    heroSub: "As an independent brokerage, we place coverage with admitted and excess-surplus lines carriers rated by A.M. Best. More markets means more options - and more competitive rates.",
    heading: "Partial list of the carriers we work with",
    amBest: "Companies Rated by A.M. Best",
    disclaimer: "This list is subject to change if a carrier is no longer writing insurance in Florida.",
    ctaTitle: "Don't see a market you need?",
    ctaSub: "We work with many more admitted and surplus lines carriers than we can list. Premium financing is available. Tell us about your risk and we'll find the right market.",
  },
  quotePage: {
    heroOverline: "Request a Quote",
    heroTitle: "Need a competitive quote for your property or business?",
    heroSub: "Commercial Property, BOP Business Owner Policy, Professional Liability, General Liability, Umbrella or Flood - fill out the form and we'll shop our markets on your behalf.",
    formTitle: "Tell us what you need",
    formSub: "Takes less than a minute. No obligation.",
    labelName: "Full Name *",
    labelPhone: "Phone *",
    labelEmail: "Email *",
    labelType: "Insurance Type *",
    labelMessage: "Tell us about your property or business",
    phName: "Your name",
    phPhone: "(954) 555-0123",
    phEmail: "you@example.com",
    phType: "Select a coverage type",
    phMessage: "Property address or type, current carrier, renewal date - anything that helps us prepare.",
    otherType: "Other / Not Sure",
    submitBtn: "Get My Quote",
    sending: "Sending…",
    successTitle: "Quote request received",
    successSub: "Thank you - we've received your request and will be in touch shortly. Need an answer right away?",
    rateLimitError: "Too many requests. Please try again later or call us at 954-540-2539.",
    sideTitle: "Prefer to talk it through?",
    sideSub: "Speak directly with an insurance professional.",
    armandoSuffix: "- Armando",
    dianaSuffix: "- Diana",
    officeTitle: "Visit our office",
    getDirections: "Get Directions \u2192",
  },
  notFound: {
    title: "This page doesn't exist",
    sub: "The page you're looking for may have moved. Request a quote or call us and we'll be glad to help.",
  },
  a11y: {
    openLabel: "Open accessibility options",
    close: "Close accessibility panel",
    title: "Accessibility",
    textSize: "Text Size",
    textSizeValues: ["Default", "Large", "Larger"],
    contrast: "High Contrast",
    grayscale: "Grayscale",
    highlightLinks: "Highlight Links",
    underlineLinks: "Underline Links",
    readableFont: "Readable Font",
    pauseMotion: "Pause Motion",
    bigCursor: "Large Cursor",
    reset: "Reset All",
    statementLink: "Accessibility Statement",
  },
  statement: {
    overline: "Accessibility",
    title: "Website Accessibility Statement",
    updated: "Last Updated: February 27, 2026",
    sections: [
      {
        h: "Our Commitment to Accessibility",
        p: ["We are committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying relevant accessibility standards to enhance usability and inclusivity. Our goal is to provide a website that is accessible to the widest possible audience, regardless of technology or ability."],
      },
      {
        h: "Accessibility Standards",
        p: ["We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA, which are widely recognized as the industry standard for website accessibility. Accessibility is an ongoing process, and we are actively working toward improving the accessibility and usability of our website."],
      },
      {
        h: "Accessibility Technology & Tools",
        p: ["To support our accessibility efforts, we have deployed industry-standard accessibility technology designed to enhance usability and assist visitors with disabilities. These tools may provide features such as:"],
        list: ["Screen reader enhancements", "Keyboard navigation improvements", "Color contrast adjustments", "Text size and spacing controls", "Focus indicators", "Additional accessibility interface options"],
        p2: ["This technology helps us improve accessibility while we continue broader auditing, remediation, and development efforts."],
      },
      {
        h: "Ongoing Improvement",
        p: ["Accessibility is an ongoing initiative. We are:"],
        list: ["Reviewing site content and functionality regularly", "Working with developers and accessibility tools", "Identifying and remediating barriers", "Incorporating accessibility into future design and development"],
        p2: ["We understand accessibility is a continuous journey and are committed to making improvements over time."],
      },
      {
        h: "Third-Party Content",
        p: ["Some areas of the website may include third-party content, plugins, or integrations that are not fully controlled by us. While we encourage vendors to provide accessible content, we cannot guarantee accessibility of third-party features. However, we welcome feedback regarding any issues encountered."],
      },
      {
        h: "Feedback & Assistance",
        p: ["If you experience difficulty accessing any part of this website, need assistance, or would like to request content in an alternative format, please contact us. Please include:"],
        list: ["The page URL", "Description of the issue", "Your preferred contact method"],
        p2: ["We aim to respond within a reasonable timeframe and will make reasonable efforts to provide accessible alternatives."],
      },
      {
        h: "Good Faith Efforts",
        p: ["We are making good-faith efforts to comply with accessibility standards and improve usability for individuals with disabilities. Despite our efforts, some content may not yet fully meet the strictest accessibility standards due to the evolving nature of technology and ongoing updates. We appreciate your understanding as we continue improving accessibility."],
      },
      {
        h: "Terms & Conditions - Accessibility Clause",
        p: ["We are committed to providing an accessible website experience for all users and strive to follow recognized accessibility standards, including WCAG guidelines. We have implemented industry-standard accessibility tools and continue to review, update, and improve our website to enhance accessibility. Because accessibility is an ongoing process, some areas of the website may not yet fully conform to all accessibility standards. If you encounter accessibility barriers, please contact us so we can provide assistance, offer alternative access, and address the issue where feasible. Nothing in these Terms is intended to limit any rights available under applicable accessibility laws."],
      },
    ],
    contactTitle: "Contact Us About Accessibility",
    contactSub: "Reach us by phone or email - or through our Contact / Quote page.",
  },
};
